import axios from "axios";

// axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_api,
  // baseURL: 'https://api.saiadosofabr.com.br/api',
  // baseURL: 'https://saiapi.wmatech.com.br/api',
  headers: {
    'X-Requested-With':'XMLHttpRequest',
    'Content-Type':'application/json'
  }
});

export default axiosInstance;